import React, { useEffect, useState, useCallback } from 'react';
import { Container, Box, Button, Dialog, DialogTitle, DialogContent, InputAdornment, IconButton, Typography, TextField, Stack, Avatar, FormControlLabel, Checkbox , Tooltip} from '@mui/material';

import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import CircularProgress from '@mui/material/CircularProgress';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import utc from "dayjs/plugin/utc";
import CloseIcon from '@mui/icons-material/Close';
import { book } from '../../services/turf'
import { useSnackbar } from "../../context/snackbar";

dayjs.extend(utc);
dayjs.extend(isSameOrBefore);


const styles = {
    root: {
      margin: 0,
      padding:2,
    },
    closeButton: {
      position: 'absolute',
      right: 1,
      top: 1,
      color: 'palette.grey[500]',
    },
    body:{
        width:'100%',
        display:'flex',
        height: {xs:'60vh', sm:'60vh', md:'100%', lg:'100%'}
      },
    dateCont:{
        display: 'flex',
        flexDirection: 'column',
        marginBottom: 10
    },
    dateInd:{
        marginBottom: 20
    },
    summaryTable: {
      display: 'table',
      borderCollapse: 'separate',
      borderSpacing: '5px',
      mb:2,
    }
  };

const getDefaultTime = () => {
    const date = dayjs()
    const minutes = date.minute();
    const roundedMinutes = minutes < 30 ? 30 : 60;
    return date.startOf("hour").add(roundedMinutes, "minute");
}

const getTimeDescription = (from, to) => {
    const timeSlots = [
        { start: 0, end: 4, label: "Midnight" },
        { start: 4, end: 7, label: "Dawn" },
        { start: 7, end: 12, label: "Morning" },
        { start: 12, end: 16, label: "Afternoon" },
        { start: 16, end: 20, label: "Evening" },
        { start: 20, end: 24, label: "Night" },
    ];

    const getTimeSlot = (hour) => {
        return timeSlots.find(slot => hour >= slot.start && hour < slot.end)?.label || "Unknown Time";
    };

    const getOrdinalSuffix = (day) => {
        if (day >= 11 && day <= 13) return `${day}th`; // Special case for 11th, 12th, 13th
        switch (day % 10) {
          case 1: return `${day}st`;
          case 2: return `${day}nd`;
          case 3: return `${day}rd`;
          default: return `${day}th`;
        }
      };

    const fromSlot = getTimeSlot(from.hour());
    const toSlot = getTimeSlot(to.hour());

    const fromTime = from.format("hh:mm A"); // 12-hour format
    const toTime = to.format("hh:mm A");
    return {
        from: `${getOrdinalSuffix(from.format("DD"))} ${from.format('ddd')} ${fromTime} ${fromSlot}`,
        to: `${getOrdinalSuffix(to.format("DD"))} ${to.format('ddd')} ${toTime} ${toSlot}`
    }
    /*if (fromDateStr === toDateStr) {
        return fromSlot === toSlot ?
        `${getOrdinalSuffix(from.format("DD"))} ${fromTime} to ${toTime} ${fromSlot} `
        : `${getOrdinalSuffix(from.format("DD"))} ${fromTime}  ${fromSlot} to ${toTime} ${toSlot} `
    } else {
        return `${getOrdinalSuffix(from.format("DD"))} ${fromSlot} ${fromTime} to ${getOrdinalSuffix(to.format("DD"))} ${toSlot} ${toTime}`;
    }*/
}
const SummarySection = ({timeDiff, rate, description }) => {
  return (    
    <Box component="fieldset" sx={styles.summaryTable}>
        <legend>Summary</legend>
        <Box sx={{ mb: 1, display: "table-row"}}>
          <Typography sx={{ display: "table-cell" }}>
            From 
          </Typography>
          <Typography sx={{ display: "table-cell" }}>
            {description.from}
          </Typography>
        </Box>
        <Box sx={{ mb: 1, display: "table-row"}}>
          <Typography sx={{ display: "table-cell" }}>
            To 
          </Typography>
          <Typography sx={{ display: "table-cell" }}>
            {description.to}
          </Typography>
        </Box>
        <Box sx={{ mb: 1, display: "table-row"}}>
          <Typography sx={{ display: "table-cell" }}>
            Total Hours 
          </Typography>
          <Typography sx={{ display: "table-cell" }}>
            {timeDiff/60} hours
          </Typography>
        </Box>
        <Box sx={{ mb: 1, display: "table-row"}}>
          <Typography sx={{ display: "table-cell" }}>
            Rent 
          </Typography>
          <Typography sx={{ display: "table-cell" }}>
            ₹ {(timeDiff/60) * rate}
          </Typography>
        </Box>
      </Box>
  )
}


const DialogTitleComponent =(props) => {
    const { children, onClose, ...other } = props;
    return (
      <DialogTitle style={{display: 'flex', position: 'relative'}} sx={styles.root} {...other}>
        <Typography >{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close"  style={{right: '25px', position: 'absolute'}} sx={styles.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  };

  const DateBar = ({fromDate, setFromDate, toDate, setToDate}) => {
    const now = dayjs();
    
    // Helper to calculate min time
    const getMinTime = (date) => {
      if (!date) return null;
  
      // If the selected date is today
      if (date.isSame(now, 'day')) {
        return now.hour() < 8 ? now.set('hour', 7).set('minute', 0) : now.startOf('hour');
      }
      
      // For future dates, set minimum time to 8 AM
      return dayjs().set('hour', 7).set('minute', 0);
    };
  
    //const minTime = getMinTime(fromDate);
    //const minEndTime = getMinTime(toDate);
    //const maxTime = dayjs().set('hour', 22).set('minute', 0); // 10 PM
      return (
          <div style={styles.dateCont}>
              <div style={styles.dateInd} >
                <LocalizationProvider dateAdapter={AdapterDayjs}>                      
                    <DateTimePicker
                        label="From Date"
                        value={fromDate}
                        ampm={true}
                        //timeSteps={{  minutes: 30 }}
                        minutesStep={30}
                        format='DD/MM/YYYY HH:mm'
                        openTo="hours"
                        onChange={(newValue) => {
                            setFromDate(newValue);
                        }}
                      />
                  </LocalizationProvider>
              </div>
              <div style={styles.dateInd}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateTimePicker
                        label="To Date"
                        value={toDate}
                        ampm={true}
                        openTo="hours"
                        format='DD/MM/YYYY HH:mm'
                        minutesStep={30}
                        onChange={(newValue) => {
                            setToDate(newValue);
                        }}
                      />
                    </LocalizationProvider>
              </div>
        </div>
      )
  }

const AddBooking = (props) => {

    const [fromDate, setFromDate] = useState();
    const [toDate, setToDate] = useState();
    const [showSummary, setShowSummary] = useState(false)
    const { showSnackbar } = useSnackbar();
    useEffect(()=>{
        const _date = getDefaultTime(props.selectedDay, props.x);
        setFromDate(_date)
        setToDate(_date.add(30, 'minute'))
    }, [])

    const handleAddBookingClose = () => {
        props.setOpen(false)
    }
    
    let timeDiff;
    if (toDate && fromDate) {
      timeDiff = toDate.diff(fromDate, 'minute')
    }
    const onBookClick = () => {
        setShowSummary(true)
    }
    const doBook = async() =>{
      try {
        await book(fromDate.utc().format('YYYY-MM-DD HH:mm:ss'), toDate.subtract(1, 'second').utc().format('YYYY-MM-DD HH:mm:ss'), props.turfId)
        handleAddBookingClose();
        showSnackbar("Booking added successfully!", "success");
        props.setShouldRefresh(true)
      } catch (e) {
        showSnackbar("Could not book", "error");
        console.log(e)
      }
    }
    
    if (props.open) {
        return (
            <Dialog
                sx={{height:{xs:'60vh', sm:'60vh'}}}
                fullWidth={true}
                maxWidth={"md"}
                aria-labelledby="customized-dialog-title"
                open={props.open}
            >
                <DialogTitleComponent id="customized-dialog-title" onClose={handleAddBookingClose}>
                    Add New Booking
                </DialogTitleComponent>
                <DialogContent sx={{height:{xs:'90vh', sm:'90vh'}}} dividers style={{height: '100%'}}>
                <Container sx={styles.body} style={{flexDirection:'column'}}>
                    {!showSummary && (<DateBar fromDate={fromDate} toDate={toDate} setFromDate={setFromDate} setToDate={setToDate}/>)}
                    {showSummary && (<SummarySection
                      timeDiff={timeDiff}
                      rate={props.rate}
                      description={getTimeDescription(fromDate, toDate)}
                    />)}
                    {showSummary ?
                    (<Stack direction="row">
                        <Button sx={{mr: 2}} onClick={()=>{setShowSummary(false)}} variant='outlined'>Back</Button>
                        <Button onClick={doBook} disabled={!(fromDate && toDate)} variant='contained'>Confirm</Button>
                      </Stack>)
                    :
                    (<Stack direction="row">
                        <Button sx={{mr: 2}} onClick={handleAddBookingClose} variant='outlined'>Cancel</Button>
                        <Button onClick={onBookClick} disabled={!(fromDate && toDate)} variant='contained'>Book</Button>
                      </Stack>)
                    }
                </Container>
                </DialogContent>
            </Dialog>
        )
    }
    return null;
}


export default AddBooking